import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat/chat.service';
import { StudioSidebarService } from '../../services/studio-sidebar/studio-sidebar.service';
import { StudioSidebarItem } from '@sc/types';
import { PopoverController } from '@ionic/angular';
import { defaultPopoverOptions } from '../../services/theme/theme.service';
import { AddSidebarComponent } from '../add-sidebar/add-sidebar.component';

@Component({
  selector: 'sc-studio-controls-button',
  templateUrl: './studio-controls-button.component.html',
  styleUrls: ['./studio-controls-button.component.scss'],
})
export class StudioControlsButtonComponent {
  @Input() sidebar: StudioSidebarItem;
  @Input() index: number;
  @Input() size = 'large';
  settingsPopover: HTMLIonPopoverElement;
  wasEditingSidebarsWhenPointerDown = false;

  editingSidebars$ = this.studioSidebarService.editingSidebars$;
  sidebarItems$ = this.studioSidebarService.sidebarItems$;
  sidebars = this.studioSidebarService.sidebars;

  unreadChatGroups$ = this.chatService.unreadChatGroups$;

  constructor(private studioSidebarService: StudioSidebarService, private chatService: ChatService, private popoverController: PopoverController) {}

  async addSidebar(e, index) {
    const menu = await this.popoverController.create({
      ...defaultPopoverOptions,
      component: AddSidebarComponent,
      event: e,
      componentProps: {
        index,
      },
      cssClass: 'add-sidebar-menu',
    });
    await menu.present();
  }

  removeSidebar(e, index) {
    e.stopPropagation();
    this.studioSidebarService.removeSidebarItem(index);
  }

  pointerDown() {
    // to avoid toggling sidebar when user is trying to start editing sidebars
    // check if the user was editing sidebars when pointer was down to decide if the click event should be triggered
    this.wasEditingSidebarsWhenPointerDown = this.studioSidebarService.editingSidebars$.value;
  }

  click(index) {
    if (this.wasEditingSidebarsWhenPointerDown === false && this.studioSidebarService.editingSidebars$.value === true) {
      return;
    }
    this.studioSidebarService.toggleSidebar(undefined, undefined, index);
  }
}
